import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_STOCK_ACCOUNT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_STOCK_ACCOUNT_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_STOCK_ACCOUNT_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/stock-account`,
    method: 'GET',
  })
);

export default apiCall;

const FETCH_INVESTCORE_STOCKS_ACCOUNT_ENABLE_MUTUAL_FUND_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STOCKS_ACCOUNT_ENABLE_MUTUAL_FUND_API';

export const enableMutualFundAccount = createApiCall(
  FETCH_INVESTCORE_STOCKS_ACCOUNT_ENABLE_MUTUAL_FUND_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/nhsv/enable-mutual-fund`,
    method: 'POST',
    notify: true,
  })
);
